import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUsers = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/users`, {params});
};

export {
    getUsers
}